import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../Vas';
import CustomerModel from '../../models/Customer';
import '../../css/CustomerCard.css';
import { PagingTable } from 'component-lib';
import { DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, SchoolHistoryModel } from 'models-lib';

class SchoolHistory extends Component
{
    constructor(props)
    {
        super(props);
        this.state = new CustomerModel([this]);
        this.state.CurrentView = "CustomerData";
        this.state.DocumentList=[];
        this.CustomerId = localStorage.getItem('vas_customerId');
        this.state.Upload=false;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.SchoolHistoryModel = new SchoolHistoryModel([this]);
    }

    componentWillMount(){
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });
      this.SchoolHistoryModel.SetRequest(this.Request);
    }

    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Labels["SchoolHistory"]);
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "SchoolHistory"){
            let logs = [];
            
            let result = this.SchoolHistoryModel.SchoolHistory;
            for(let i = 0; i< result.length; i++){
              let log = {
                Id:i.toString(),
                ContractNumber:result[i].ContractNumber?result[i].ContractNumber:'',
                CustomerNumber:result[i].CustomerNumber?result[i].CustomerNumber:'',
                Date:result[i].Date !== null && result[i].Date !== ""?DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(result[i].Date,true,localStorage.getItem('vas_language'))):'',
                Reason:result[i].Reason?result[i].Reason:'',
                Text:result[i].Text?result[i].Text:''
              };
              logs.push(log);
            }

            localStorage.setItem('csvDataContent',JSON.stringify(logs));    
        
            if (me.refs.table){
            me.refs.table.setState({ Data: logs, Count: this.SchoolHistoryModel.Count, Limit: this.SchoolHistoryModel.Limit, Start: this.SchoolHistoryModel.Start, End: this.SchoolHistoryModel.Start+logs.length });
            }
            me.setState({ Count:this.SchoolHistoryModel.Count });
            $("#LoadingIcon").removeClass().addClass('hide');
          }
        });
    }

    load(sendData){

      this.SchoolHistoryModel.GetSchoolHistory(sendData);

      $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    render()
    {
        return (
          <div className={"form"} >
            <table style={{ width: '1200px' }} >
            <thead>
                <tr>
                  <th style={{ width:'100%' }}></th>
                  <th><div 
                    id={"LoadingIcon"}
                    className={'hide'} ></div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <PagingTable 
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table" 
                      TableReference={this} 
                      DataBaseTable={"DokumenteZusatz"} 
                      Selectable={false} 
                      Limit={this.state.Limit} 
                      Start={this.state.Start} 
                      End={this.state.End} 
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["ContractNumber"],Vas.Resources.Labels["CustomerNr"],Vas.Resources.Labels["Date"],Vas.Resources.Labels["Reason"],Vas.Resources.Labels["Action"]]}
                      Keys={["ContractNumber","CustomerNumber","Date","Reason","Text"]} 
                      Data={this.state.Data}
                      Download={false}
                      Modus={"DBBus"}
                      Add={false} 
                      Border={false}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      AppURL={Vas.ApplicationUrl} 
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      CWidth={[70,70,70,120,200]}
                      CSV={true}
                      CSVController={"Schools"}
                      CSVTableName={"Historie"}
                      ExtendShownResultsOnPage={true}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default SchoolHistory;
